// MySQL DECIMAL columns come back as full-precision strings (e.g.
// "319.20000000"). Clean that up the same way the mobile app's
// formatPrice() helper does — whole numbers with no decimals, otherwise 2.
export function formatPrice(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num % 1 === 0 ? num.toString() : num.toFixed(2);
}
